/*
 *  Banner Section
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2019/16/13
 */
import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-homebanner]';
export const CAROUSEL_SELECTOR = '[data-homebanner-products]';
export const CAROUSEL_DOTS_SELECTOR = '[data-product-carousel-dots]';

export class HomeBanner extends CarouselSection {
  constructor(container) {
    super(container);

    this.container = container;
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.navigationDots = container.find(CAROUSEL_DOTS_SELECTOR);
    
    // carousel
    this.slick = this.initCarousel(this.carouselContainer);
    this.initDotsCarousel();//Initialise Slick dots
  }

  initDotsCarousel() {
    this.dotsSlick = this.navigationDots.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      draggable: false,
      adaptiveHeight: false,
      swipe: false,
      swipeToSlide: false,
      touchMove: false,
      accessibility: false,
      asNavFor: this.carouselContainer,
      centerMode: true,
      centerPadding: 10,
      focusOnSelect: true,
      mobileFirst: true
    });
  }
  

  optionOverrides() {
    return {
      infinite: this.carouselContainer.data('infinite') == false ? false : true,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 1,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 1,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      speed: this.carouselContainer.data('slide-speed') || 500,
      dots: false,
      arrows: this.carouselContainer.data('arrows') == false ? false : true,
      adaptiveHeight: this.carouselContainer.data('adaptiveheight') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      customPaging : function(slider, i) {
      let thumb = $(slider.$slides[i]).data();
      let no = i+1;
      if (no < 10) {
        return '<a> 0'+no+'</a>'
      } else{
        return '<a>'+no+'</a>'
      }
      },
      fade: true,
      asNavFor: this.navigationDots,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    }
  }

}

register(CONTAINER_SELECTOR, HomeBanner);